(function () {
  var VIEW_PARAM = 'all';
  var abortController = null;
  var lastPathname = window.location.pathname;
  var bound = false;

  function getSectionId() {
    var grid = document.getElementById('product-grid');
    return grid ? grid.dataset.id : null;
  }

  function getGridSection() {
    var main = document.querySelector('.gh-collection-main');
    return main ? main.closest('.shopify-section') : null;
  }

  function withViewParam(href) {
    var url = new URL(href, window.location.origin);
    url.searchParams.set('view', VIEW_PARAM);
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    return url;
  }

  function isModifiedClick(event) {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
  }

  function collectionHandleFromPath(pathname) {
    var match = pathname.replace(/\/$/, '').split('/collections/')[1];
    return match ? match.split('/')[0] : '';
  }

  function updateActive(pathname) {
    var handle = collectionHandleFromPath(pathname);
    document.querySelectorAll('.warwood-collection-filter__item').forEach(function (item) {
      var link = item.querySelector('a[href]');
      if (!link) return;
      var linkText = link.textContent.trim();
      var itemHandle = collectionHandleFromPath(new URL(link.href, window.location.origin).pathname);
      var isActive = itemHandle === handle && handle !== '';
      // if(linkText.includes('All')) {
      //   var collectionTitle = document.querySelector('.warwood-collection-filter').dataset.collectionTitle;
      //   if(collectionTitle.includes(linkText)) {
      //     isActive = true;
      //   }
      // }
      item.classList.toggle('active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function setLoading(isLoading) {
    var main = document.querySelector('.gh-collection-main');
    var collection = document.querySelector('.gh-collection-main .collection');
    var items = document.querySelector('.warwood-collection-filter__items');
    if (main) {
      main.classList.toggle('is-loading', isLoading);
      main.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }
    if (collection) collection.classList.toggle('loading', isLoading);
    if (items) items.classList.toggle('is-disabled', isLoading);
  }

  function resetFacets(searchParams) {
    if (!window.FacetFiltersForm) return;
    FacetFiltersForm.filterData = [];
    FacetFiltersForm.searchParamsInitial = searchParams;
    FacetFiltersForm.searchParamsPrev = searchParams;
    FacetFiltersForm._ghPath = window.location.pathname;
  }

  function updateDocumentTitle() {
    var heading = document.querySelector('.gh-collection-title');
    if (!heading) return;
    var shopName = document.title.split('–').pop();
    document.title = heading.textContent.trim() + (shopName ? ' –' + shopName : '');
  }

  function patchFacets() {
    if (!window.FacetFiltersForm || typeof FacetFiltersForm.renderPage !== 'function' || FacetFiltersForm._ghCollectionPatched) {
      return;
    }
    FacetFiltersForm._ghCollectionPatched = true;
    FacetFiltersForm._ghPath = window.location.pathname;

    var originalRenderPage = FacetFiltersForm.renderPage.bind(FacetFiltersForm);
    FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash) {
      var params = new URLSearchParams(searchParams || '');
      params.set('view', VIEW_PARAM);
      var nextParams = params.toString();
      var path = window.location.pathname;

      if (FacetFiltersForm._ghPath && FacetFiltersForm._ghPath !== path) {
        FacetFiltersForm._ghPath = path;
        FacetFiltersForm.searchParamsPrev = nextParams;
        FacetFiltersForm.filterData = [];
        return;
      }

      FacetFiltersForm._ghPath = path;
      originalRenderPage(nextParams, event, updateURLHash !== false);
    };
  }

  function navigate(href, pushState) {
    var sectionId = getSectionId();
    var sectionEl = getGridSection();
    var targetUrl = withViewParam(href);

    if (!sectionId || !sectionEl) {
      window.location.href = targetUrl.toString();
      return;
    }

    if (
      pushState &&
      targetUrl.pathname === window.location.pathname &&
      targetUrl.search === window.location.search
    ) {
      return;
    }

    if (abortController) abortController.abort();
    abortController = new AbortController();

    var fetchUrl = new URL(targetUrl.toString());
    fetchUrl.searchParams.set('sections', sectionId);

    setLoading(true);

    fetch(fetchUrl.toString(), { signal: abortController.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Section request failed');
        return response.json();
      })
      .then(function (data) {
        var html = data[sectionId] || Object.values(data)[0];
        if (!html) throw new Error('Missing section HTML');

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newSection = doc.querySelector('.gh-collection-main');
        if (!newSection) throw new Error('Missing collection markup');

        var newWrapper = newSection.closest('.shopify-section') || doc.body;
        sectionEl.innerHTML = newWrapper.innerHTML;

        lastPathname = targetUrl.pathname;
        resetFacets(targetUrl.search.slice(1));
        updateActive(targetUrl.pathname);
        updateDocumentTitle();
        patchFacets();

        if (pushState) {
          history.pushState(
            { ghCollectionNav: true, searchParams: targetUrl.search.slice(1) },
            '',
            targetUrl.toString()
          );
        }

        var title = document.querySelector('.gh-collection-title');
        if (title) title.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        window.location.href = targetUrl.toString();
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function collectionFilterLink(event) {
    return event.target.closest('.warwood-collection-filter__item a[href]');
  }

  function paginationLink(event) {
    return event.target.closest('#ProductGridContainer .pagination a[href]');
  }

  function onDocumentClick(event) {
    if (isModifiedClick(event)) return;

    var filterLink = collectionFilterLink(event);
    if (filterLink) {
      event.preventDefault();
      navigate(filterLink.href, true);
      return;
    }

    var pageLink = paginationLink(event);
    if (pageLink) {
      event.preventDefault();
      navigate(pageLink.href, true);
    }
  }

  function onPopState() {
    if (window.location.pathname === lastPathname) return;
    lastPathname = window.location.pathname;
    navigate(window.location.href, false);
  }

  function bind() {
    if (bound) return;
    bound = true;
    document.addEventListener('click', onDocumentClick, true);
    window.addEventListener('popstate', onPopState);
  }

  function init() {
    if (!document.querySelector('.warwood-collection-filter')) return;
    bind();
    patchFacets();
    updateActive(window.location.pathname);
  }

  bind();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
